<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="text-center fw-bold w-100">{{ "smart_tool_tips.edit" | translate }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body overflow-x-hidden p-3">
        <form class="col-12" [formGroup]="toolTipInfoForm">
            <div class="bg-card shadow-md rounded p-2 mb-3">
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-input
                            [label]="'smart_tool_tips.descriptionAE' | translate"
                            formControlName="descriptionAE"
                            controlName="descriptionAE"
                            [invalid]="checkInvalid('descriptionAE')"
                            [required]="true"
                        ></adaa-form-input>
                    </div>
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-input
                            [label]="'smart_tool_tips.descriptionEN' | translate"
                            formControlName="descriptionEN"
                            controlName="descriptionEN"
                            [invalid]="checkInvalid('descriptionEN')"
                            [required]="true"
                        ></adaa-form-input>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal=footer d-flex justify-content-center mt-3">
        <div class="my-2">
            <adaa-form-action-buttons
                [saveButtonTitle]="'common.form.button.save' | translate"
                [cancelButtonTitle]="'common.form.button.cancel' | translate"
                (cancelClicked)="modal.close()"
                (saveClicked)="submit()"
            ></adaa-form-action-buttons>
        </div>
    </div>
</ng-template>
